export default __webpack_public_path__ + "static/media/canada.0c7f14f9.svg";